/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// core components
import Pagination from "components/Pagination/Pagination.js";

export default function PaginationDocs() {
  return (
    <Pagination
      pages={[
        { text: "Previous" },
        { text: 1 },
        { text: 2 },
        { text: 3 },
        { text: "Next" },
      ]}
    />
  );
}
